import { Component, OnInit } from '@angular/core';
import { AuthService, ConstantService, HelperService, ApiService, PaginationService } from '../../core/services';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-podcast-home',
  templateUrl: './podcast-home.component.html',
  styleUrls: ['./podcast-home.component.css']
})
export class PodcastHomeComponent implements OnInit {

  podcastCategory:any='';
    popularPodcastList:any = [];


  public loadScript() {
    var isFound = false;
    var scripts: any = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null) {
        isFound = false;
        if (scripts[i].getAttribute('src').includes("assets/js/slick.min.js")) {
          // scripts.slice(1, i);
          scripts[i].parentNode.removeChild(scripts[i])
        }
        if (scripts[i].getAttribute('src').includes("assets/js/custom.js")) {
          // scripts.slice(1, i);
          scripts[i].parentNode.removeChild(scripts[i])
        }
      }
    }
    if (!isFound) {
      var dynamicScripts = ["assets/js/slick.min.js", "assets/js/custom.js"];
      // var dynamicScripts = ["assets/js/jquery.ba-throttle-debounce.min.js"];
      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
  }


  constructor(private authSvc: AuthService,
    private constantSvc: ConstantService,
    private apiSvc: ApiService,
    private helperSvc: HelperService,
    private pagerService: PaginationService,
    private router: Router,    private spinner: NgxSpinnerService,

    private _route: ActivatedRoute) { }

  ngOnInit(): void {
    this.getPodcastCategoryList();
    this.getPopularPodcasts();
  }

  getPodcastCategoryList() {
    this.spinner.show();
    this.apiSvc.getService(this.constantSvc.APIConfig.GETPODCASTCATEGORYWITHPODCAST, '').subscribe(
      res => {
        if (res) {
          let data = res;
          this.podcastCategory = res.categories;
          this.loadScript();
          this.spinner.hide();
        }
      }, err => {
        this.spinner.hide();
      }
    );
  }

  getPopularPodcasts() {

    this.apiSvc.getService(this.constantSvc.APIConfig.POPULARPODCAST, '/all').subscribe(
      res => {
        if (res) {
          let data = res;
          this.popularPodcastList = data.data;

        }
      }, err => {

      }
    );

  }

}
